import LazyChartControllerBase from './helpers/lazy_chart_controller_base';
import { ChartFormattingMixin } from './concerns/chart_formatting_mixin';
import Chart from 'chart.js/auto';

export default class extends LazyChartControllerBase {
  static values = { inputs: String, title: String, dataFormat: String };
  static targets = ['chartcanvas'];

  _buildChart() {
    Object.assign(this, ChartFormattingMixin);
    this.dataFormatValue ||= 'timeDuration';
    const chartData = JSON.parse(this.inputsValue);

    const chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        title: {
          display: true,
          text: this.titleValue,
          position: 'top',
          align: 'center',
        },
        tooltip: {
          callbacks: {
            label: this.tooltipFormat(),
          },
        },
      },
      scales: {
        y: {
          grid: {
            display: true,
            drawOnChartArea: true,
            drawTicks: true,
          },
          ticks: {
            color: '#b2b3bd',
            crossAlign: 'center',
            callback: this.tooltipFormat(),
          },
        },
        x: {
          grid: {
            display: true,
            drawOnChartArea: true,
            drawTicks: true,
          },
          ticks: {
            crossAlign: 'inner',
            color: '#b2b3bd',
            maxTicksLimit: 15,
          },
        },
      },
    };

    new Chart(this.chartcanvasTarget, {
      type: 'line',
      data: chartData,
      options: chartOptions,
    });
  }
}
